import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { message } from './firebase';
import './index.css';

message();

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="902594411134-4tv4188j3874dflqhn816gb4fpipu74l.apps.googleusercontent.com">
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
